var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chats",attrs:{"id":"container"}},[_c('head-comp',{staticStyle:{"position":"absolute"}}),_c('chat-screen',{staticStyle:{"position":"absolute"}}),_c('chat-box',{staticStyle:{"position":"absolute"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }